<div class="family-base-container-component">
  <div>
    <a [href]="'/' + member.getMemberUsername">
      <button *ngIf="member.getMemberUsername" class="bulb-familymember-rectangle">
        <div class="bulb-familymember-avatar">
          <div *ngIf="!member.getMemberAvatarURL" class="img-placeholder">
            <bulb-user-avatar
              [displayProps]="member.getDisplayProps"
            ></bulb-user-avatar>
          </div>
          <div *ngIf="member.getMemberAvatarURL" class="bulb-composite-header-avatar">
            <img [src]="member.getMemberAvatarURL" class="img-placeholder">
          </div>
        </div>
        <p>{{member.getMemberDisplayName}}</p>
      </button>
    </a>
  </div>
</div>
